import { ChangeDetectionStrategy, Component, computed, DestroyRef, inject, OnInit, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NotificationsService } from '@shared/services/notifications.service';
import { NotificationViewModel } from '@shared/models/notifications.view-model';
import { NotificationItemComponent } from './notification-item/notification-item/notification-item.component';

@Component({
    selector: 'app-notification-menu',
    templateUrl: './notification-menu.component.html',
    styleUrls: ['./notification-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NotificationItemComponent]
})
export class NotificationMenuComponent implements OnInit {
  private readonly notificationsService = inject(NotificationsService);
  private readonly destroyRef = inject(DestroyRef);

  public readonly notifications = signal<NotificationViewModel[]>([]);
  public readonly hasNotifications = computed(() => this.notifications().length > 0);

  ngOnInit(): void {
    this.loadNotifications();
  }

  private loadNotifications(): void {
    this.notificationsService.notifications
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(notifications => {
        this.notifications.set(notifications);
      });
  }
}
